import { Locale } from 'shared/i18n/interface'
import { useSelector } from 'react-redux'
import { useTranslations } from 'app/features/Gallery/hooks/useTranslations'
import { getCareTilePriceSelector } from '~/app/store/config'
import { getCareTilePricingText } from '~/app/features/Gallery/components/PreviewArea/CareTile/hooks/getCareTilePricingText'
import { usePricingContext } from '~/app/features/FragmentRoot/contexts/pricing/context'

type CareTileContent = {
  captionText: string
  ctaText: string
  eyebrowText: string
  headingText: string
}

type CareTileContentHook = (locale: Locale) => CareTileContent

export const useCareTileContent: CareTileContentHook = (locale) => {
  const localize = useTranslations()
  const price = useSelector(getCareTilePriceSelector)
  const pricingContext = usePricingContext()
  const vatInclusive = pricingContext?.getPricingContext()?.vatInclusive ?? true
  const pricingText = getCareTilePricingText(locale, price, vatInclusive)

  if (pricingText) {
    return {
      ctaText: localize('CareTileCTATextFromPrice', { price: pricingText }),
      captionText: localize('CareTileCaptionTextFromPrice'),
      eyebrowText: localize('CareTileEyebrowText'),
      headingText: localize('CareTileCTAText'),
    }
  }

  return {
    ctaText: localize('CareTileCTAText'),
    captionText: localize('CareTileCaptionTextVariant'),
    eyebrowText: localize('CareTileEyebrowText'),
    headingText: localize('CareTileHeadingVariant'),
  }
}
